export default "<div >\n   <!-- <app-entertainment-carousel-banner  [vendorPrefix]=\"vendorPrefixId\"></app-entertainment-carousel-banner> -->\n</div>\n";